import * as React from "react";
import { Table} from "react-bootstrap"

import { ILoaderProps } from "../domene"

import { formatterFelt } from "./felt";
import { Kolonne } from "./Kolonne";
import { side, hentData, klasse } from "./components";
import { ModellComponent } from "./ModellComponent";
import { appContext } from "../App/appContext";
import { replaceRoute } from "./navigation";
import { setUrlParam } from "./url";
import { sokeForm } from "../Component/sok";

import Models = Gf.Web.Models;
import Url = require("./url");

export abstract class ListeComponent<TFeltType, TModel extends Models.EntitetListeModell<TFeltType>>
extends ModellComponent<TModel> {

    protected abstract getKolonner(model: TModel): Kolonne<TFeltType>[];

    private readonly rowHeight = 37;
    private scrollDiv: HTMLDivElement;
    private url = appContext.getCurrentLocation();
    private pixelOffset: number;
    private itemOffset: number;
    protected pageOffset: number;
    protected order: string | undefined;
    private lastScroll = 0;
    private lastModel: TModel | undefined;

    protected constructor(
        props: ILoaderProps,
        protected path: string,
        protected tittel: string,
        protected onClick: (rad: Models.ListeRadModell, model: TModel) => void,
        protected visSok = true,
        protected readonly pageSize = 10) {
        super(props);
        this.refreshQuasiState();
    }

    renderPossiblyNotLoaded(): JSX.Element | null {
        //appContext.log("ListComponent renderPossiblyNotLoaded");
        this.refreshQuasiState();
        return this.renderWithModel(this.getModel());
    }

    // TODO: Don't use quasi state
    private refreshQuasiState() {
        this.updateOffsets(appContext.getUrlParamInt("offset") || 0);
        this.order = appContext.getUrlParam("order");
    }
    
    private updateOffsets(pixelOffset: number) {
        this.pixelOffset = pixelOffset;
        this.itemOffset = Math.floor(this.pixelOffset / this.rowHeight);
        this.pageOffset = Math.floor(this.itemOffset / this.pageSize);
    }
    
    private getQuery() { return appContext.getQueryUrlParam(); }
    
    getModelPath() { return this.getModelPathPage(0); }

    getModelPathPage(page: number) { return `/${this.path}/Liste?offset=${((page + this.pageOffset) * this.pageSize)}&take=${this.pageSize}&order=${this.order || ""}&q=${this.getQuery() || ""}` }

    renderWithModel(model: TModel | undefined) {
        return side(this.tittel, <div>{(this.props as any).children}{this.renderTabell(model,
            this.laster.last<TModel>(this.getModelPathPage(1)))}</div>);
    }

    private tegnRader(model: TModel | undefined): JSX.Element[] | null {
        if (model === undefined) {
            return null;
        }
        const kolonner = this.getKolonner(model);
        return model.Rader.map(r =>
            <tr key={r.EntitetId} className="tabellRad" onClick={() => this.onClick(r, model)}>{kolonner
                .map((k, i) => k === undefined
                    ? null
                    : <td key={i} style={{width: k.width}} className={klasse(k) }>{formatterFelt(hentData(model, r, k.feltType),
                        k.definisjon,
                        this.laster) }</td>)

            }
            </tr>);
    }

    private setScrollPosition(): void {
        if (this.scrollDiv) {
            const offsetHeight = this.scrollDiv.offsetHeight;
            const pixelOffset = this.scrollDiv.scrollTop;
            this.lastScroll = pixelOffset;
            if (offsetHeight > 0) {
                this.updateOffsets(pixelOffset);
                this.navigateTo(setUrlParam(this.url, "offset", pixelOffset === 0 ? undefined : `${pixelOffset}`));
            }
        }
    }

    private setScrollDiv(div: HTMLDivElement): void {
        this.scrollDiv = div;
        if (div) {
            div.scrollTop = this.pixelOffset;
        }
    }
    
    private sorter(feltType: TFeltType, sorteringer: Models.Sortering<TFeltType>[]): void {
        if (this.scrollDiv) {
            let url = this.url;
            const resultat = sorteringer.slice();
            const sortering = resultat.find(it => it.FeltType === feltType);
            const desc = (sortering && (sortering === resultat[0])) ? !sortering.Descending : false;
            if (sortering) {
                const i = resultat.indexOf(sortering);
                resultat.splice(i, 1);
            }
            resultat.splice(0, 0, {
                FeltType: feltType,
                Descending: desc
            }); 
            this.order = resultat.map(s => s.Descending ? -s.FeltType : s.FeltType).join(".");
            this.updateOffsets(0);
            url = setUrlParam(url, "offset", undefined);
            url = setUrlParam(url, "order", this.order);
            this.navigateTo(url);
            this.forceUpdate();
        }
    }
    
    private navigateTo(url: string): void {
        this.url = url;
        replaceRoute(url);
    }

    private renderTabell(model1: TModel | undefined, model2: TModel | undefined): JSX.Element | null {
        const model12 = model1 || model2;
        const model = model12 || this.lastModel;
        if (!model) {
            return null;
        }
        this.lastModel = model;
        const url = appContext.getCurrentLocation();
        const preItems = this.pageOffset * this.pageSize;
        const showItems = (model1 ? model1.Rader.length : 0) + (model2 ? model2.Rader.length : 0);
        const postItems = model.TotalCount - preItems - showItems; 
        const spacerStyle = (items: number) => ({ height: items * this.rowHeight + "px", display: items > 0 ? "table-row" : "none" });
        const kolonner = this.getKolonner(model);
        const scrollHeight = this.rowHeight * Math.min(this.pageSize, model.TotalCount);
        const scrollTableStyle = { height: scrollHeight + "px" };
        const scrolling = model.TotalCount > this.pageSize;
        const onScroll = () => window.requestAnimationFrame(() => this.setScrollPosition()); 
        const clickHeader = (kolonne: Kolonne<TFeltType>) => window.requestAnimationFrame(() => 
            this.sorter(kolonne.feltType, model.Sorteringer));
        const sortert = (kolonne: Kolonne<TFeltType>) => {
            const sorteringer = model.Sorteringer; 
            const sortering = sorteringer.find(it => it.FeltType === kolonne.feltType);
            const i = sortering ? sorteringer.indexOf(sortering) : -1;
            const style = { opacity: (i === 0) ? 1 : ((i === -1) ? 0 : (0.6 / (i + 1))) };
            return sortering
                ? <span style={style}>{sortering.Descending ? "\u25BC" : "\u25B2"}</span>
                : null; 
        };
        return <div className="scrollTableParent">
                   {this.visSok ? sokeForm([], this, "Søk i tabell") : null}
                   <Table striped hover className="tabellHode"> 
                       <thead> 
                       <tr>
                           {kolonner.map((k, i) => k === undefined ? null : <th key={i} style={{width: k.width}} 
                               className={klasse(k)} onClick={() => { clickHeader(k) }}>{k.navn}{sortert(k)}</th>) }
                           {scrolling ? <th className="scrollSpacer" /> : null}
                       </tr>
                       </thead>
                   </Table>
                   <div className="scrollTable" style={scrollTableStyle} ref={(div: HTMLDivElement) => this.setScrollDiv(div)} onScroll={onScroll}>
                       <Table striped hover>
                           <tbody>
                           <tr className="rowSpacer" style={spacerStyle(preItems)} />
                           { this.tegnRader(model1) }
                           { this.tegnRader(model2) }
                           <tr className="rowSpacer" style={spacerStyle(postItems)} />
                           </tbody>
                       </Table>
                   </div>
               </div>;
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Component/ListeComponent.tsx